import React, { useCallback, useState } from "react";
import WeatherForm from "./WeatherForm";
import GetWeatherInfo from "./GetWeatherInfo";

const API_KEY = "968144acb5be0268d342b60b5375b8fa";

type WeatherState = {
  temp?: number;
  city?: string;
  country?: string;
  humidity?: number;
  description?: string;
  error?: string;
};

function Weather() {
  const [weather, setWeather] = useState<WeatherState>({
    temp: undefined,
    city: undefined,
    country: undefined,
    humidity: undefined,
    description: undefined,
    error: undefined
  });

  const getWeatherUpdate = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const form = e.currentTarget;
      const fd = new FormData(form);
      const city = String(fd.get("city") ?? "").trim();
      const country = String(fd.get("country") ?? "").trim();
      const api_call = await fetch(
        `http://api.openweathermap.org/data/2.5/weather?q=${city},${country}&appid=${API_KEY}&units=metric`
      );
      const getData = (await api_call.json()) as {
        main?: { temp: number; humidity: number };
        name?: string;
        sys?: { country?: string };
        weather?: { description: string }[];
      };
      if (city && country) {
        setWeather({
          temp: getData.main?.temp,
          city: getData.name,
          country: getData.sys?.country,
          humidity: getData.main?.humidity,
          description: getData.weather?.[0]?.description,
          error: undefined
        });
      } else {
        setWeather({
          temp: undefined,
          city: undefined,
          country: undefined,
          humidity: undefined,
          description: undefined,
          error: "Please input the required details"
        });
      }
    },
    []
  );

  return (
    <div>
      <WeatherForm getWeatherUpdate={getWeatherUpdate} />
      <GetWeatherInfo
        temp={weather.temp}
        city={weather.city}
        country={weather.country}
        humidity={weather.humidity}
        description={weather.description}
        error={weather.error}
      />
    </div>
  );
}

export default Weather;
